import { t } from "@lingui/macro"
import { IconButton, Stack } from "@mui/material"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { ArrowBackFilled24 } from "src/components/icons/ArrowBackFilled24"
import { Cross16 } from "src/components/icons/Cross16"
import { SegmentTypeIcon } from "src/components/SegmentPicker/components/SegmentTypeIcon"
import { Field } from "src/components/SegmentPicker/components/SegmentParent/styled"
import { SegmentPickerStore } from "src/components/SegmentPicker/store"
import { useStore } from "src/store/lib/useStore"

export const SegmentParent = observer(() => {
    const store = useStore(SegmentPickerStore)

    const handleHistoryBackClick = useCallback(async () => {
        store.setPreviousFilter()
        await store.availableSegments.loadInitialPage()
    }, [store])

    const handleClearHistoryClick = useCallback(async () => {
        store.resetFilter()
        await store.availableSegments.loadInitialPage()
    }, [store])

    if (store.parent == null) {
        return null
    }

    return (
        <Stack direction="row">
            <IconButton
                title={t`segment-picker.go-back-in-history`}
                onClick={handleHistoryBackClick}
            >
                <ArrowBackFilled24 />
            </IconButton>
            <Field
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
            >
                <Stack direction="row" spacing={1} alignItems="center">
                    <SegmentTypeIcon type={store.parent.type} size={24} />
                    <span>{store.parent?.name}</span>
                </Stack>
                <IconButton
                    title={t`segment-picker.clear-history`}
                    onClick={handleClearHistoryClick}
                >
                    <Cross16 />
                </IconButton>
            </Field>
        </Stack>
    )
})
